import { apiSlice } from "../../../app/api/apiSlice";

export const sourceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSource: builder.query({
      query: () => "source",
      keepUnusedDataFor: 5,
    }),
    getSingleSource: builder.query({
      query: (id) => `source/${id}`,
    }),
    postSource: builder.mutation({
      query: (newSource) => ({
        url: "source",
        method: "POST",
        body: newSource,
      }),
    }),
    updateSource: builder.mutation({
      query: ({ id, values }) => ({
        url: `source/${id}`,
        method: "PUT",
        body: values,
      }),
    }),
    deleteSource: builder.mutation({
      query: (sourceId) => ({
        url: `source/${sourceId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetSourceQuery,
  useGetSingleSourceQuery,
  usePostSourceMutation,
  useUpdateSourceMutation,
  useDeleteSourceMutation,
} = sourceApiSlice;
